
import SplitText from '../vendor/gsap/SplitText';
import WebFont from "webfontloader";
import gsap from "gsap";

class HeroAnim {
  constructor() {
    this.initHeroAnimation();
  }
  initHeroAnimation() {
    const preloadFonts = () => new Promise((resolve) => {
      WebFont.load({
        custom: {
          families: ['TT Commons'],
        },
        active: resolve
      });
    });

    Promise.all([preloadFonts()]).then(() => {
      this.playHeroAnimation();
    });
  }

  playHeroAnimation() {
    // const itemsToReveal = ['.hero__item', '.hero__custom > *', 'section.hero + section > *'];
    const itemsToReveal = ['.js-hero-anim'];

    // prepare title
    window.wrapper = document.querySelector('.site');
    const heroTitle = window.wrapper.querySelectorAll('.hero__title');
    const textSplitted = new SplitText(heroTitle, {
      type: 'lines, words',
      linesClass: 'lines',
      wordsClass: 'words'
    });

    // calculating timestamp for item transition time start
    const totalWords = textSplitted.words.length;
    const timestamp = (totalWords * 0.05) / 1.5;
    const tmp = Math.pow(10, 2);
    const timestampRound = Math.round( timestamp*tmp )/tmp;

    // create timeline
    const tl = gsap.timeline({
      paused: true
    });

    tl.set(heroTitle, {
      autoAlpha: 1,
    })

    tl.from(textSplitted.words, {
      y: '110%',
      stagger: 0.05,
      duration: 0.9,
      force3D: true,
      ease: 'power4.out'
    });

    // tl.fromTo(itemsToReveal, {
    //   y: '20',
    // }, {
    //   autoAlpha: 1,
    //   y: 0,
    //   stagger: 0.12,
    //   duration: 0.9,
    //   ease: 'power4.out'
    // }, timestampRound > 0.25 ? 0.25 : timestampRound);

    tl.play();
  }
}


export default HeroAnim;
